import Hero from "../components/Hero";
import PressStrip from "../components/sections/PressStrip";
import Problem from "../components/sections/Problem";
import Manifesto from "../components/sections/Manifesto";
import Marquee from "../components/sections/Marquee";
import Framework from "../components/sections/Framework";
import TestimonialsStrip from "../components/sections/TestimonialsStrip";
import SolutionsSection from "../components/sections/SolutionsSection";
import HowWeWork from "../components/sections/HowWeWork";
import Schools from "../components/sections/Schools";
import Libraries from "../components/sections/Libraries";
import CaseStudy from "../components/sections/CaseStudy";
import About from "../components/sections/About";
import Contact from "../components/sections/Contact";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <PressStrip />
      <Problem />
      <Manifesto />
      <Framework />
      <Marquee />
      <TestimonialsStrip />
      <SolutionsSection />
      <HowWeWork />
      <Schools />
      <Libraries />
      <CaseStudy />
      <About />
      <Contact />
    </div>
  );
}
